
import PinIndicator from "@/pages/join/components/PinIndicator";
import PinNumberPad from "@/pages/join/components/PinNumberPad";
import { observer } from "mobx-react-lite";
import PinGuideTextArea from "./PinGuideTextArea";

interface IProps {
    pin: string;
    isPinCheckFailed: boolean;
    pinStep: 'CHECK' | 'NEW' | 'CONFIRM';
    isNotMatchPin: boolean;
    onClickNumberBtn: (number: string) => void;
    OnClickDeleteBtn: () => void;
    onClickAllClearBtn: () => void;
}

const PinSettingView = observer(({pin, isPinCheckFailed, pinStep, isNotMatchPin, onClickNumberBtn, OnClickDeleteBtn, onClickAllClearBtn}: IProps) => {


    return (
        <div className="wrap wrap_temporary pin join-pin">
        <div className="container" style={{ marginTop: '17rem' }}>
            <h2 className="fw-b">{'PIN 비밀번호 입력'}</h2>
            {pinStep === 'CHECK' && (
                <p className="body-s-n fw-b">{"기존 PIN 비밀번호를 입력해주세요."}</p>
            )}
            {pinStep === 'NEW' && (
                <p className="body-s-n fw-b">{"새로운 PIN 비밀번호를 6자리로 입력해주세요."}</p>
            )}
            {pinStep === 'CONFIRM' && (
                <p className="body-s-n fw-b">{"다시 한번 입력해주세요."}</p>
            )}
            <PinIndicator pin={pin} />
            <PinGuideTextArea pinStep={pinStep} isPinCheckFailed={isPinCheckFailed} isNotMatchPin={isNotMatchPin} />
            <PinNumberPad
                onClickNumberBtn={onClickNumberBtn}
                OnClickDeleteBtn={OnClickDeleteBtn}
                onClickAllClearBtn={onClickAllClearBtn}
            />
        </div>
    </div>
    )
})  

export default PinSettingView